/**
 * Google Ads lead conversions, tiered by which form was actually submitted.
 *
 * WHY THIS IS JS AND NOT LIQUID
 * Shopify's `form.posted_successfully?` is NOT scoped to the form that posted --
 * it is true inside EVERY `{% form 'contact' %}` block on the page. A product page
 * carries five contact forms (four cc-pdf-capture slots + one pdp-msg quote form),
 * so the old Liquid `{% render 'cc-fire-conversion' %}` inside cc-main-product fired
 * the lead conversion on every PDF download too. Verified 2026-09-16 by loading
 * /products/...?contact_posted=true: the quote success block and its conversion tag
 * both rendered with no quote submitted.
 *
 * Shopify DOES anchor each form's action to its own id (`/contact#pdp-msg-...`),
 * so after the post-redirect the URL hash identifies the real submitter. That is
 * the only reliable discriminator, and it is client-side only.
 *
 * VALUES are enforced server-side on the conversion action
 * (always_use_default_value = true), so the `value` sent here is advisory and the
 * tiers can be retuned in Google Ads without a theme deploy.
 */
(function () {
  'use strict';

  var TAG = 'AW-18102440940';

  var TIERS = {
    high: { label: 'UacqCOreufocEOyn9bdD', value: 500 }, // "Lead - High Intent"
    low:  { label: 'QEQ9CO3eufocEOyn9bdD', value: 50  }  // "Lead - Low Intent"
  };

  // Matched as prefixes against the posted form id, first match wins.
  // Keep in sync with ops/form-schema.md.
  var RULES = [
    ['pdp-msg',                     'high'], // quote-request
    ['ContactQuoteForm',            'high'], // contact-page
    ['PickQuoteForm',               'high'], // pick-quiz
    ['cc-pdf-capture',              'low' ], // pdf-download
    ['cc-collection-brochure-form', 'low' ], // brochure-download
    ['cc-popup-form',               'low' ]  // popup-offer (currently disabled)
  ];

  function tierFor(formId) {
    for (var i = 0; i < RULES.length; i++) {
      if (formId.indexOf(RULES[i][0]) === 0) return RULES[i][1];
    }
    return null;
  }

  function alreadyFired(key) {
    try {
      if (sessionStorage.getItem(key)) return true;
      sessionStorage.setItem(key, '1');
      return false;
    } catch (e) {
      return false; // private mode / blocked storage: prefer firing over losing it
    }
  }

  function fire() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (params.get('contact_posted') !== 'true') return;

    var formId = (window.location.hash || '').replace(/^#/, '');
    if (!formId) return;          // no anchor: cannot attribute a tier, stay silent
    var tier = tierFor(formId);
    if (!tier) return;            // unknown form: do not guess a value

    // One conversion per submitted form per session; a refresh must not re-fire.
    if (alreadyFired('ccLeadConv:' + formId)) return;

    var t = TIERS[tier];
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('event', 'conversion', {
      send_to: TAG + '/' + t.label,
      value: t.value,
      currency: 'USD',
      transaction_id: formId + ':' + Date.now()
    });

    // ChatGPT Ads (OpenAI pixel, layout <head>) — one untiered lead event for any
    // real form submission, same gate + dedupe as the Google Ads conversion above.
    if (typeof window.oaiq === 'function') {
      window.oaiq('measure', 'lead_created', { type: 'customer_action' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fire);
  } else {
    fire();
  }
})();
